<div class="filter-wrapper">
  <div class="ag-date-title">{{'app.general.filter' | translate}}</div>

  <div class="date-wrapper">
    <span>{{ 'app.general.fromDate' | translate }}</span>
    <div class="ag-date-picker-field">
      <mat-form-field appearance="outline">
        <input matInput placeholder="dd/mm/yyyy" [matDatepicker]="picker" [formControl]="dateFrom" />
        <mat-datepicker-toggle matSuffix [for]="picker" />
        <mat-datepicker #picker panelClass="ag-custom-component-popup" [touchUi]="true" />
      </mat-form-field>
    </div>

    <span>{{ 'app.general.toDate' | translate }}</span>
    <div class="ag-date-picker-field">
      <mat-form-field appearance="outline">
        <input matInput placeholder="dd/mm/yyyy" [matDatepicker]="picker2" [formControl]="dateTo" />
        <mat-datepicker-toggle matSuffix [for]="picker2" />
        <mat-datepicker #picker2 panelClass="ag-custom-component-popup" [touchUi]="true" />
      </mat-form-field>
    </div>
  </div>

  <div class="filter-actions">
    <app-general-button
      [buttonStyle]="'primary'"
      [buttonHeight]="32"
      [buttonName]="'app.general.approval'"
      [disabled]="!dateFrom.value || !dateTo.value"
      (buttonClicked)="applyFilter()"
    />
    <app-general-button
      [buttonStyle]="'secondary'"
      [buttonHeight]="32"
      [buttonName]="'app.general.cancel'"
      (buttonClicked)="resetFilter()"
    />
  </div>
</div>
